'use strict';

/*
  MessageService

  Handles displaying/clearing  message instances on Notification Centre.

  Parameters:
    presenter [APIPresenter] (required):
      Reference to the APIPresenter in order to communicate with SOA and create data models.
*/

function MessageService(presenter) {
  this.messagesModelReady = $.Deferred();
  this._presenter = presenter;
  this._loadMessagesCallbackId = null;

  this.loadMessages = function (callback, forceUpdateModel) {
    if (this._presenter.hasAction('account.index_messages')) {
      if (forceUpdateModel || typeof this._presenter.models.messages === 'undefined') {
        if (this._loadMessagesCallbackId === null) {
          this._loadMessagesCallbackId = this._presenter.addCallbackToAction('account.index_messages', this._onLoadMessages.bind(this, callback));
        }
        this._presenter.performAction('account.index_messages');
      } else if (this._presenter.models.messages && !this._presenter.models.messages._initialized) {
        $.when(this.messagesModelReady).then(this._onLoadMessages.bind(this, callback));
      } else {
        this._onLoadMessages(callback, this._presenter.models.messages);
      }
    } else if (typeof callback === 'function') callback({ errors: [{ code: 404, key: 'no_action_error' }] }, 404);
  };

  this.updateMessagesInBulk = function (actionType, callback) {
    if (this._presenter.models.messages && this._presenter.models.messages._initialized) {
      if (this._presenter.hasAction('messages.bulk_update_messages')) {
        if (actionType === 'seen') {
          this._presenter.performAction('messages.bulk_update_messages', { mark_all_as_seen: true }, callback.bind(this));
        } else {
          this._presenter.performAction('messages.bulk_update_messages', { mark_all_as_read: true }, this.loadMessages.bind(this, callback, false));
        }
      } else if (typeof callback === 'function') callback({ errors: [{ code: 404, key: 'no_action_error' }] }, 404);
    } else if (this._loadMessagesCallbackId !== null) {
      $.when(this.messagesModelReady).then(this.updateMessagesInBulk.bind(this, actionType, callback));
    } else {
      this.loadMessages(this.updateMessagesInBulk.bind(this, actionType, callback));
    }
  };

  // Need to invoke this at component destroy method.
  this.destroy = function () {
    if (this._loadMessagesCallbackId) {
      this._loadMessagesCallbackId = this._presenter.removeCallbackFromAction('account.index_messages', this._loadMessagesCallbackId);
    }
  };

  this._onLoadMessages = function (callback, data, status) {
    var _this = this;

    if (data || status === 200) {
      if (!this._presenter.models.messages) {
        this._presenter.createModel('messages', { data: data });
      } else {
        this._presenter.updateModel('messages', data);
      }
      this.messagesModelReady.resolve();
    }
    this._presenter.addComputedVariable('has_unread_messages', ['messages'], function () {
      return _this._presenter.hasAction('messages.bulk_update_messages');
    });
    if (typeof callback === 'function') callback(data, status);
  };
}